import { render } from "./App.vue?vue&type=template&id=603c7d40"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
script.render = render

export default script